export default __webpack_public_path__ + "static/media/serve-png.facfa885.png";